/**
 * Standardized size constants for SPDS components.
 *
 * These constants provide a consistent vocabulary for component sizing
 * across the design system. While components may use the same size values,
 * the visual meaning is component-specific (e.g., 'small' button vs 'small' card).
 */

// Individual size tokens
export const DEFAULT = 'default';
export const LARGE = 'large';
export const MEDIUM = 'medium';
export const NORMAL = 'normal';
export const SMALL = 'small';
export const TINY = 'tiny';
export const X_LARGE = 'x-large';

// Component-specific size arrays
export const BADGE_SIZES = Object.freeze([NORMAL, SMALL]);
export const LOADING_SPINNER_SIZES = Object.freeze([TINY, SMALL, MEDIUM, LARGE, X_LARGE]);
export const BUTTON_SIZES = Object.freeze([NORMAL, SMALL]);
export const CARD_SIZES = Object.freeze([LARGE, MEDIUM, SMALL]);
export const FLYOUT_SIZES = Object.freeze([SMALL, LARGE]);
export const TOGGLE_SIZES = Object.freeze([DEFAULT, LARGE, SMALL]);

export default {
  // Individual tokens
  LARGE,
  MEDIUM,
  NORMAL,
  SMALL,
  TINY,
  X_LARGE,
  // Component arrays
  BADGE_SIZES,
  LOADING_SPINNER_SIZES,
  BUTTON_SIZES,
  CARD_SIZES,
  FLYOUT_SIZES,
  TOGGLE_SIZES,
};
